import Rollbar from 'rollbar';

import { ROLLBAR_IGNORED_KEYWORDS } from './constants/whitelist-messages';

const { VITE_ROLLBAR_ACCESS_TOKEN, VITE_ENV } = import.meta.env;

const hasIgnoredKeywords = (message: string): boolean => {
  return ROLLBAR_IGNORED_KEYWORDS.some((keyword) => message.includes(keyword));
};

interface RollbarPayload extends Rollbar.Dictionary {
  body?: {
    message?: {
      body: string;
      extra: object;
    };
    trace?: {
      // Examples:
      // - TypeError: this.ai.close is not a function. (In 'this.ai.close()', 'this.ai.close' is undefined)
      // - UnknownError: Connection to Indexed Database server lost. Refresh the page to try again
      // - (unknown) Script error.
      exception?: {
        class: string;
        message: string;
      };
      frames?: Array<{
        filename: string;
        lineno: number;
        colno: number;
      } | {
        filename: unknown;
        lineno: null;
        colno?: 0;
      }>;
    };
  };
}

const opts: Rollbar.Configuration = {
  accessToken: VITE_ROLLBAR_ACCESS_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  checkIgnore: (isUncaught: boolean, args: Rollbar.LogArgument[], { body = {} }: RollbarPayload) => {
    const bodyMessage = body?.message?.body;
    const exceptionMessage = body?.trace?.exception?.message;
    const frameFilenames = body?.trace?.frames?.map((frame) => frame.filename) ?? [];

    return [
      bodyMessage,
      exceptionMessage,
      ...frameFilenames
    ].some((item = '') => typeof item === 'string' && hasIgnoredKeywords(item));
  },
  payload: {
    environment: VITE_ENV
  },
  enabled: VITE_ENV !== 'local'
};

// Instantiate the Rollbar Logger
const rollbarLogger = new Rollbar(opts);

export default rollbarLogger;
